/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    template: undefined,
    tagName: 'div',
    initialize: function () {
        this.$el.addClass(this.options.class);
        this.template = templates[this.template] || this.template;
        if (typeof this.template === 'string') {
            this.options.missingTemplate = this.template;
            this.template = templates.contentNotFound;
            console.log('html.initialize - missing template (%s)', this.options.path);
        }
    },
    render: function () {
        this.$el.html(this.template(this.options));
        return this;
    }
});
